/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileNewsletterNextInfo } from '../../models/profile-newsletter-next-info';

export interface NextNewsletterInfo$Params {
  id: number;
}

export function nextNewsletterInfo(http: HttpClient, rootUrl: string, params: NextNewsletterInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterNextInfo>> {
  const rb = new RequestBuilder(rootUrl, nextNewsletterInfo.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileNewsletterNextInfo>;
    })
  );
}

nextNewsletterInfo.PATH = '/rest/profile/{id}/newsletter/next-newsletter-info';
